import { render, staticRenderFns } from "./staff-app-layout.vue?vue&type=template&id=32d5ef24&"
import script from "./staff-app-layout.vue?vue&type=script&lang=js&"
export * from "./staff-app-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports